import { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react';

interface InputProps {
    page: number;
    totalPages: number;
    onSetPage: (page: number) => void;
}
const Input = ({ page, onSetPage, totalPages }: InputProps) => {
    const [value, setVaue] = useState('');

    useEffect(() => {
        setVaue(String(page));
    }, [page]);

    const onHandleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            const enteredPage = Number(value);
            if (enteredPage >= 1 && enteredPage <= totalPages) {
                onSetPage(enteredPage);
            }
        }
    };

    const onChangeHandler = (e: ChangeEvent<HTMLInputElement>): void => {
        if (e.target.value === '') {
            setVaue('');
            return;
        }
        if (!/^\d+$/.test(e.target.value)) {
            return;
        }
        if (Number(e.target.value) > totalPages) {
            return;
        }
        
        setVaue(e.target.value);
    };

    return (
        <input
            type='text'
            value={value}
            onKeyPress={onHandleKeyPress}
            onChange={onChangeHandler}
        />
    )
}

export default Input;
